import { store } from "@/store/store";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { DashboardStatsDto } from "@/shared/dtos/dashboard-stats.dto";

export interface StatsParams {
    desde?: string;
    hasta?: string;
    pedidos?: string;
    incluirEfectivo?: boolean;
}

@Module({ namespaced: true, name: "dashboardstatsModule", store, dynamic: true })
class dashboardstatsModule extends VuexModule {
    public stats: DashboardStatsDto = new DashboardStatsDto();
    public loading: boolean = false;

    @Action({ commit: "onGetStats" })
    public async getStats(params: StatsParams) {
        return await ssmHttpService.get(API.dashboardstats, { params }, false);
    }

    @Mutation
    public onGetStats(res: any) {
        this.stats = res ? new DashboardStatsDto(res) : new DashboardStatsDto();
    }
}

export default getModule(dashboardstatsModule);
